export const faqs = [
  {
    question: 'JM Comic 是什么？',
    answer: 'JM Comic 是一个广受欢迎的在线漫画阅读平台，提供海量正版与同人漫画资源。平台涵盖少年漫画、少女漫画、同人漫画、青年漫画等多个类别，支持在线阅读、离线下载、社区互动等功能，致力于为漫画爱好者提供优质的阅读体验。',
  },
  {
    question: 'JM Comic 如何注册账号？',
    answer: '访问JM Comic官方网站，点击右上角的"注册"按钮，输入手机号码获取验证码，设置密码和昵称，完成实名认证后即可成功注册。整个注册流程仅需3-5分钟。详细信息请参考我们的注册教程文章。',
  },
  {
    question: 'JM Comic 的会员费用是多少？',
    answer: 'JM Comic 提供免费注册的普通会员和付费的高级会员。高级会员提供月度（¥15/月）、季度（¥40/季）和年度（¥128/年）三种订阅方案。年度订阅性价比最高，折合每月仅需约¥10.7。',
  },
  {
    question: 'JM Comic 支持离线下载吗？',
    answer: '支持！高级会员每月可享受100话的离线下载额度。您可以在WiFi环境下提前下载喜欢的漫画章节，在没有网络连接时也能畅享阅读。下载内容在会员有效期内可随时阅读。',
  },
  {
    question: 'JM Comic 可以在哪些设备上使用？',
    answer: 'JM Comic 支持多平台使用，包括：Web网页版（通过浏览器访问）、iOS App（App Store下载）、Android App（官网或应用商店下载）。所有平台账号互通，阅读进度自动同步。',
  },
  {
    question: 'JM Comic 的漫画画质如何？',
    answer: 'JM Comic 提供多种画质选择：标准画质（720P）适合普通会员日常阅读，高清画质（1080P）和超清画质（4K）为高级会员专享。平台采用先进的图片压缩和加载技术，确保流畅阅读体验的同时呈现最佳画质。',
  },
  {
    question: 'JM Comic 上的漫画是正版的吗？',
    answer: '是的，JM Comic 高度重视版权保护。平台上的漫画作品均获得了正版授权，同人漫画板块也严格遵守相关版权规定。我们致力于为创作者和读者建立一个尊重知识产权的健康生态。',
  },
  {
    question: 'JM Comic 如何联系客服？',
    answer: '您可以通过以下方式联系JM Comic客服团队：在App或网页版中点击"我的-帮助与反馈"提交工单，或发送邮件至官方客服邮箱。高级会员享有优先客服通道，问题将得到更快速的处理。',
  },
  {
    question: 'JM Comic 可以退款吗？',
    answer: '高级会员订阅支持7天内申请退款。已使用的会员权益将按比例扣除相应费用后返还剩余金额。退款申请请通过客服渠道提交，需提供支付凭证和退款原因。',
  },
  {
    question: '如何确保 JM Comic 账号安全？',
    answer: '建议您：设置强密码（包含大小写字母、数字和特殊字符）、开启二次验证、绑定安全手机和邮箱、不要在公共设备上保存登录状态、警惕冒充官方客服的诈骗信息。官方永远不会索要您的密码。',
  },
];